import React, { useState } from 'react';

import { Link } from 'react-router-dom';
import './styles/Header.css'; // a CSS file for styling

import CloseIcon from '@mui/icons-material/Close';
import MenuIcon from '@mui/icons-material/Menu';
// Header.js

export default function Header() {

    const [active, setActive] = useState(false);

    const toggleMenu = () => {
        setActive(!active);
    };
    
    return (
        <header className="header">
            <div className='header_logo'>
                <h1>Samuel Gyamfi</h1>
            </div>
            <nav className={`navbar ${active ? 'active' : ''}`}>
                <ul>
                    <div className="closed">
                        <CloseIcon className='close' onClick={toggleMenu}/>
                    </div>
                    <li>
                        <Link to="#home" onClick={toggleMenu}>Home</Link>
                    </li>
                    <li>
                        <Link to="#about" onClick={toggleMenu}>About</Link>
                    </li>
                    <li>
                        <Link to="#projects" onClick={toggleMenu}>Projects</Link>
                    </li>
                    <li>
                        <Link to="#blog" onClick={toggleMenu}>Blog</Link>
                    </li>
                    <li>
                        <Link to="#contact" onClick={toggleMenu}>Contact</Link>
                    </li>
                </ul>
            </nav>
            <div className='changer'>
                <MenuIcon className='menu' onClick={toggleMenu} />
            </div>
        </header>
    );
}
